import { createContext, ReactNode, useContext, useState } from 'react';

import { ADMIN_TOKEN_KEY, adminApi } from '../services/api';

interface Admin { id: number; username: string; full_name: string | null }
interface AdminValue {
  admin: Admin | null;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
}

const Ctx = createContext<AdminValue | null>(null);
const ADMIN_KEY = 'zpos_admin';

export function AdminAuthProvider({ children }: { children: ReactNode }) {
  const [admin, setAdmin] = useState<Admin | null>(() => {
    try {
      return localStorage.getItem(ADMIN_TOKEN_KEY) ? JSON.parse(localStorage.getItem(ADMIN_KEY) || 'null') : null;
    } catch {
      return null;
    }
  });

  const login = async (username: string, password: string) => {
    const { data } = await adminApi.post('/auth/admin/login', { username, password });
    localStorage.setItem(ADMIN_TOKEN_KEY, data.access_token);
    localStorage.setItem(ADMIN_KEY, JSON.stringify(data.admin));
    setAdmin(data.admin);
  };
  const logout = () => {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    localStorage.removeItem(ADMIN_KEY);
    setAdmin(null);
  };
  return <Ctx.Provider value={{ admin, login, logout }}>{children}</Ctx.Provider>;
}

export function useAdmin(): AdminValue {
  const v = useContext(Ctx);
  if (!v) throw new Error('useAdmin outside AdminAuthProvider');
  return v;
}
